module.exports = __webpack_public_path__ + "img/21_52.2ccd6e19.png";